export default {"src":"/_next/static/media/arrow2.ad8e5a7f.svg","height":5,"width":5,"blurWidth":0,"blurHeight":0};